import { AppContext } from "01Data/AppData";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Typography,
  styled,
} from "@mui/material";
import { CognitoUser } from "amazon-cognito-identity-js";
import { FC, useContext, useState } from "react";
import { Account } from "../01Data/Account";

type DialogResult = "ok" | "cancel";

type DialogProps = {
  open: boolean;
  onClose: (result: DialogResult) => void;
  account: Account;
  user: CognitoUser;
};

const ErrorText = styled(Typography)(() => ({
  fontSize: "0.8rem",
  color: "#f00",
  whiteSpace: "pre-line",
}));

const TotpDialogContent: FC<DialogProps> = ({
  open,
  onClose,
  account,
  user,
}) => {
  const [totpCode, setTotpCode] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleApply = async () => {
    try {
      await account.confirmSignIn(user, totpCode);
      // console.log(output);
      onClose("ok");
    } catch (error) {
      setErrorMessage(`コードが正しくありません。もう一度試してください。`);
    }
  };

  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      open={open}
      onClose={() => onClose("cancel")}
      aria-labelledby="totp-dialog-title"
    >
      <DialogTitle id="totp-dialog-title">MFA 認証</DialogTitle>
      <DialogContent>
        <DialogContentText>MFA コードを入力してください。</DialogContentText>
        <TextField
          autoComplete="off"
          autoFocus
          required
          type="text"
          inputProps={{ inputMode: "numeric" }}
          sx={{ width: "10rem" }}
          variant="filled"
          margin="normal"
          label="MFA コード"
          onChange={(e) => {
            setTotpCode(e.target.value);
          }}
        />
        {errorMessage ? <ErrorText>{errorMessage}</ErrorText> : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleApply}>ログイン</Button>
        <Button onClick={() => onClose("cancel")}>ログイン画面に戻る</Button>
      </DialogActions>
    </Dialog>
  );
};

export const useTotpDialog = () => {
  const a = useContext(AppContext);
  const [open, setOpen] = useState(false);
  const [resolve, setResolve] = useState<(value: DialogResult) => void>();

  const openTotpDialog = () => {
    setOpen(true);
    return new Promise<DialogResult>((resolve) => {
      setResolve(() => resolve);
    });
  };
  const onClose = (result: DialogResult) => {
    setOpen(false);
    if (resolve) {
      resolve(result);
    }
  };

  const TotpDialog: FC<{ user: CognitoUser }> = (props) => (
    <TotpDialogContent
      open={open}
      onClose={onClose}
      account={a.account}
      user={props.user}
    />
  );

  return {
    TotpDialog,
    openTotpDialog,
  };
};
